// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_3l1Dl","icon":"index_icon_2f3qG"};